function addClassToSpecificLink() {
    // Check if the body element has the class 'template-article'
    if (document.body.classList.contains('template-article')) {
        // Select all <strong> elements
        const strongElements = document.querySelectorAll('strong');

        strongElements.forEach((strong) => {
            // Check if the <strong> element contains a <span> with underline style
            const span = strong.querySelector('span[style*="text-decoration: underline"]');
            if (span) {
                // Check if the <span> contains an <a> element
                const link = span.querySelector('a');
                if (link) {
                    // Add the desired classes to the <a> element
                    span.style.textDecoration = 'none';
                    link.style.textDecoration = 'none';
                    link.classList.add('button', 'button--regular', 'button--outline');
                }
            }
        });
    }
}

function initMobileMenuListener() {
    const searchIcon = document.querySelector('.site-header .mobile-search-basket-wrapper .search-bar-toggle');
    searchIcon.addEventListener('click', function() {
        const mobileSearch = document.querySelector('.site-header #mobile-search-menu');
        const headerContainer = document.querySelector('.site-header .header-container');

        mobileSearch.classList.toggle('active');
        headerContainer.classList.toggle('search-active');

        if (mobileSearch.classList.contains('active')) {
            // Enable the animation but then remove it
            setTimeout(() => {
                mobileSearch.style.animation = 'none';
                mobileSearch.style.overflow = 'visible';
                mobileSearch.querySelector('input').focus();
            }, 300)

            const overlay = document.querySelector('#search-results-overlay-mobile');

            overlay.addEventListener('click', function() {
                mobileSearch.classList.remove('active');
                headerContainer.classList.remove('search-active');
                mobileSearch.style.overflow = 'hidden'
            });
        }
    })
}

function modifyTitleElement() {
    const titleElement = document.querySelector('.jdgm-rev-widg__title');

    if (titleElement) {
        titleElement.innerHTML = 'Klantenreviews';
        setTimeout(() => {
            titleElement.innerHTML = 'Klantenreviews';
        }, 100);
    }
}

function fixProductTeaserCountryTags() {
    // get all the products from .products-list-wrapper .product-item
    const products = document.querySelectorAll('.product-item');

    // loop over all the products
    products.forEach(product => {
        const countryTag = product.querySelector('.tags .country');
        const tasteTag = product.querySelector('.tags .taste');
        const countryTagParent = countryTag?.parentElement;
        const tasteTagParent = tasteTag?.parentElement;

        if (!countryTag || !tasteTag) {
            if (countryTagParent && tasteTagParent) {
                countryTagParent.style.opacity = 1;
                tasteTagParent.style.opacity = 1;
            }

            return;
        }

        const tagsWrapper = product.querySelector('.tags');

        if (!tagsWrapper) {
            countryTagParent.style.opacity = 1;
            tasteTagParent.style.opacity = 1;
            return;
        }

        const currentTag = tagsWrapper.getAttribute('data-tag');

        if (!currentTag) {
            countryTagParent.style.opacity = 1;
            tasteTagParent.style.opacity = 1;
            return;
        }

        let isTeaTag = false;
        let isTeaCountryTag = false;

        // get all the tea tastes via .sidebar-custom .nav-item.tea-tastes .nav-section-items .nav-element a and then the textContent
        const teaTastes = Array.from(document.querySelectorAll('.sidebar-custom .nav-item.tea-tastes .nav-section-items .nav-element a')).map(taste => taste.textContent); 
        const teaCountries = Array.from(document.querySelectorAll('.sidebar-custom .nav-item.tea-countries .nav-section-items .nav-element a')).map(country => country.textContent);

        // check if currentTag is in teaTastes but its not case sensitive if so set isTeaTag to true and same for teaCountries
        if (teaTastes.map(taste => taste.toLowerCase()).includes(currentTag.toLowerCase())) {
            isTeaTag = true;
        }

        if (teaCountries.map(country => country.toLowerCase()).includes(currentTag.toLowerCase())) {
            isTeaCountryTag = true;
        }

        if (isTeaCountryTag && countryTag.dataset.metafield) {
            countryTag.textContent = countryTag.dataset.metafield;
        }

        if (isTeaTag && tasteTag.dataset.metafield) {
            tasteTag.textContent = tasteTag.dataset.metafield
        }

        countryTagParent.style.opacity = 1;
        tasteTagParent.style.opacity = 1;
    });
}

function initSidebarRules() {
    // get giftOptionButton via .ldt-gw-order-gift-option-container 
    const giftOptionButton = document.querySelector('.ldt-gw-order-gift-option-container');
    if (!giftOptionButton) return;
    // check if there is 1 product in the cart with title contains cadeaubon
    const cartItems = Array.from(document.querySelectorAll('.cart-item .cart-item__title span'));
    const hasOnlyGiftCards = cartItems.every(item => item.textContent.toLowerCase().includes('cadeaubon'));
    if (hasOnlyGiftCards) {
        // if so hide the giftOptionButton
        giftOptionButton.style.display = 'none';
    } else {
        // if not show the giftOptionButton
        giftOptionButton.style.display = 'block';
    }
}

// Call the function when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function() {
    fixProductTeaserCountryTags();
    addClassToSpecificLink();
    initMobileMenuListener();
    modifyTitleElement();
    initSidebarRules();

    setInterval(() => {
        initSidebarRules();
    }, 1000);
}); 